export default {
  form: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/Roles/RoleDialog/styles.js